export const Exceptions = {
    EMPTY_COMPONENTS_EXCEPTION:'com.actimind.common.icalendar.builder.EmptyComponentsException',
}



// WEBPACK FOOTER //
// ./web/js/common/icalendar/constants.js